import React from "react";
import { useEditBookingContext } from "../../EditBookingContext";
import { useFormContext } from "react-hook-form";
import { Box, Grid, TextField, Typography } from "@mui/material";

const Journey = ({ referenceCode }: { referenceCode: string }) => {
  const { classes } = useEditBookingContext();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Box className={classes.titlesBoxStyle}>
        <Typography className={classes.typography} variant="h6">
          Journey
        </Typography>
      </Box>
      <Grid container spacing={3} className={classes.textAndDropdownGrids}>
        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="customerCode"
            type="text"
            label="Customer Code"
            {...register("customerCode", { valueAsNumber: true })}
            error={Boolean(errors.customerCode)}
            helperText={errors.customerCode?.message?.toString() || ""}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="referenceCode"
            label="Reference Code"
            type="text"
            value={referenceCode}
            disabled
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="globalBookingId"
            type="text"
            label="Global Booking ID"
            value={0}
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Journey;
